import { render, staticRenderFns } from "./EducationSet.vue?vue&type=template&id=68253868&scoped=true"
import script from "./EducationSet.vue?vue&type=script&lang=js"
export * from "./EducationSet.vue?vue&type=script&lang=js"
import style0 from "./EducationSet.vue?vue&type=style&index=0&id=68253868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68253868",
  null
  
)

export default component.exports